import { HeaderActions, ICategory, ISubcategory } from 'safe'
import Empty from '../../components/Display/Empty'
import LocationAnimation from '../../assets/animations/location_animation.json'
import CategoryCard from './CategoryCard'
import { useEffect, useRef, useState } from 'react'
import Modal from '../../components/Display/Modal'
import CategoryForm from './CategoryForm'
import { FiTrash2 } from 'react-icons/fi'
import SubCategoryForm from './SubCategoryForm'
import Button from '../../components/General/Button'
import { HiOutlinePencil } from 'react-icons/hi'
import SubCategoryEditForm from './SubCategoryEditForm'
import { useDispatch, useSelector } from 'react-redux'
import {
  createCategory,
  createSubcategory,
  fetchCategories,
  removeCategory,
  removeSubcategory,
  updateCategory,
  updateSubcategory,
} from '../../redux/actions/categories'
import { RootState } from '../../redux/store'
import ModalConfirm from '../../components/Display/ModalConfirm'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { IoMdCreate } from 'react-icons/io'
import axios, { AxiosResponse } from 'axios'

const Category: React.FC<CategoryProps> = ({ setHeaderActions }) => {
  const [modal, setModal] = useState<boolean>(false)
  const [modalSubCategory, setModalSubCategory] = useState<boolean>(false)
  const [modalSubCategoryEdit, setModalSubCategoryEdit] = useState<boolean>(
    false
  )
  const [editingCategory, setEditingCategory] = useState<ICategory | null>(null)
  const [selectedCategory, setSelectedCategory] = useState<ICategory | null>(
    null
  )
  const [
    selectedSubCategory,
    setSelectedSubCategory,
  ] = useState<ISubcategory | null>(null)

  const [displayConfirm, setDisplayConfirm] = useState<boolean>(false)
  const [
    subCategoryToEdit,
    setSubCategoryToEdit,
  ] = useState<ISubcategory | null>(null)

  const [idCategoryToDelete, setIdCategoryToDelete] = useState<string>('')

  const [displayConfirmCategory, setDisplayConfirmCategory] = useState<boolean>(false)


  const [subCategories, setSubCategories] = useState<undefined | any[]>([])
  const refDivScrollSubCategories = useRef<HTMLDivElement | null>(null)

  const [addNewSub, setAddNewSub] = useState<boolean>(false)

  const { addAlert } = useSnackBars()

  const dispatch = useDispatch()

  const categories = useSelector((state: RootState) => state.ctgr.categories)

  const server = process.env.REACT_APP_SERVER_URL

  const userRole = useSelector(
    (state: RootState) => state.auth.user['custom:user_role']
  )

  useEffect(() => {
    dispatch(fetchCategories())
  }, [dispatch])

  useEffect(() => {
    if (userRole !== 'seniat') {  
      setHeaderActions({
        addAction: () => setModal(true),
      })
    }
    return () => setHeaderActions(null)
  }, [setHeaderActions])

  /* Obtiene todos los elementos para asi verificar si existen o no */
  const getAllLevels = (): any[] => {
    let allCat: any = []
    categories.forEach((v) => {
      allCat.push(v)
      allCat.push(...v.children)
    })
    return allCat
  }

  const onSubmitSave = async (values: ICategory): Promise<void> => {
    try {
      addAlert({ message: 'Creando categoria...', status: 'loading' })
      await dispatch(createCategory(values))
      addAlert({ message: 'Categoria creada con éxito', status: 'success' })
    } catch (e) {
      addAlert({ message: 'Error al crear categoria', status: 'error' })
    } finally {
      setModal(false)
    }

    // try {
    //   dispatch(createCategory(values))
    // } catch (e) {
    // } finally {
    //   setModal(false)
    // }
  }

  const onSubmitEdit = async (values: ICategory): Promise<void> => {
    try {
      addAlert({ message: 'Actualizando categoria...', status: 'loading' })
      await dispatch(updateCategory(values))
      addAlert({
        message: 'Categoria actualizada con éxito',
        status: 'success',
      })
      setEditingCategory(null)
    } catch (e) {
      addAlert({ message: 'Error al actualizar categoria', status: 'error' })
    } finally {
      setModal(false)
    }
  }

  const onSubmitSubCategory = async (values): Promise<void> => {
    try {
      addAlert({ message: 'Creando subcategoria...', status: 'loading' })
      await dispatch(
        createSubcategory({
          idCategory: selectedCategory && selectedCategory.id,
          ...values,
        })
      )
      addAlert({ message: 'Subcategoria creada con éxito', status: 'success' })
    } catch (e) {
      addAlert({ message: 'Error al crear subcategoria', status: 'error' })
    } finally {
      setModal(false)
    }
  }

  const onUpdateSubCategory = async (values): Promise<void> => {
    console.log("values...", values)
    console.log("val", selectedSubCategory)
    
    try {
      addAlert({ message: 'Actualizando subcategoria...', status: 'loading' })
      // await dispatch(
      //   updateSubcategory({
      //     id: selectedSubCategory && selectedSubCategory.id,
      //     ...values,
      //   })
      // )
      let body = {
        ...selectedSubCategory,
        ...values,
      }
      await axios.patch(`${server}/inventory/subcategory`, body)
      setSubCategories(prevSubCategories => prevSubCategories?.map(subCategory => {
        if (subCategory.id === selectedSubCategory?.id) {
          return {
            ...subCategory,
            ...values
          }
        }
        return subCategory
      }))
      addAlert({
        message: 'Subcategoria actualizada con éxito',
        status: 'success',
      })
    } catch (e) {
      setEditingCategory(null)
      addAlert({ message: 'Error al actualizar subcategoria', status: 'error' })
    } finally {
      setModalSubCategoryEdit(false)
    }
  }

  const onDelete = async (): Promise<void> => {
    try {
      addAlert({ message: 'Eliminando categoria...', status: 'loading' })
      await dispatch(removeCategory(idCategoryToDelete))
      addAlert({ message: 'Categoria eliminada con éxito', status: 'success' })
    } catch (e : any) {
      if (e.response.status === 400) {
        if (e.response.data.message.includes("items")) {
          addAlert({ message: 'No se puede eliminar esta categoría porque esta asociada con artículos en la base de datos.', status: 'error' })
        } else if (e.response.data.message.includes("items")) {
          addAlert({ message: 'No se puede eliminar esta categoría porque tiene registros contables asociados.', status: 'error' })
        } else {
          addAlert({ message: 'No se puede eliminar categoría porque está asociada con registros en la base de datos.', status: 'error' })
        }
      } else if (e.response.status === 500) {
        addAlert({ message: 'Error de servidor', status: 'error' })
      }
    } finally {
      setDisplayConfirmCategory(false)
      setModalSubCategoryEdit(false)
    }
  }

  return (
    <>
      <h2 className="font-semibold text-lg text-primary-900 dark:text-white mb-6">
        Categorias
      </h2>
      <Modal
        display={modal}
        // modalClasses="w-3/6 py-4 px-12"
        onAccept={() => null}
        onClose={() => {
          setModal(false)
          setEditingCategory(null)
        }}
        xlClasses="xl:w-2/6"
      >
        <CategoryForm
          useType={editingCategory === null ? 'create' : 'edit'}
          // categories={getAllLevels()}
          defaultValues={editingCategory}
          onCancel={() => {
            setModal(false)
            setEditingCategory(null)
          }}
          onSubmit={(values) =>
            editingCategory === null
              ? onSubmitSave(values)
              : onSubmitEdit(values)
          }
        />
      </Modal>

      <Modal
        display={modalSubCategory}
        // modalClasses="w-3/6 py-4 px-12"
        onAccept={() => null}
        onClose={() => {
          setModalSubCategory(false)
        }}
      >
        <h1 className="font-bold text-primary-900 dark:text-gray-400 mb-8 col-span-12">
          Subcategorias
        </h1>

        {subCategories?.length === 0 ? (
          <>
            <Empty
              animationProps={{
                animation: LocationAnimation,
                width: 150,
                height: 150,
              }}
            >
              <p className="font-semibold max-w-xs text-center my-4 text-sm text-coolGray-500">
                Aqui puedes crear, eliminar y editar subcategorias.
              </p>
            </Empty>
          </>
        ) : (
          <div
            className="max-h-56 overflow-y-scroll"
            ref={refDivScrollSubCategories}
          >
            {subCategories &&
              subCategories.map((subCategory) => (
                <div
                  className="rounded-lg mt-6 p-2 flex justify-between items-center"
                  key={subCategory.id}
                >
                  <div>
                    <h2 className="text-sm ml-3">{subCategory.name}</h2>
                    <h2 className="text-xs mt-2 text-primaryGray-900 ml-3">
                      {subCategory.code}
                    </h2>
                  </div>
                  <div className="flex">
                    <Button
                      classes="mt-4 border-none"
                      onClick={(e) => {
                        e.preventDefault()
                        setSelectedSubCategory(subCategory)
                        setModalSubCategoryEdit(true)
                      }}
                    >
                      <IoMdCreate size={20} className="text-primary-700" />
                    </Button>

                    <Button
                      classes="mr-4 mt-4 border-none"
                      onClick={() => {
                        setSubCategoryToEdit(subCategory)
                        setDisplayConfirm(true)
                      }}
                    >
                      <FiTrash2 size={20} className="text-danger-100" />
                    </Button>
                  </div>
                </div>
              ))}
          </div>
        )}

        <div className="mt-4">
          {/* <SubCategoryForm
            onSubmit={(values) => {
              if (refDivScrollSubCategories) {
                refDivScrollSubCategories.current?.scrollTo(0, 0)
              }
              onSubmitSubCategory(values)
            }}
            categories={getAllLevels()}
          /> */}
        </div>
      </Modal>

      <Modal
        display={modalSubCategoryEdit}
        // modalClasses="w-3/6 py-4 px-12"
        onAccept={() => null}
        onClose={() => {
          setModalSubCategoryEdit(false)
        }}
        xlClasses="xl:w-2/6"
      >
        <div>
          <h1 className="font-bold text-primary-900 dark:text-gray-400 mb-8 col-span-12">
            Editar subcategoria
          </h1>
          <SubCategoryEditForm
            defaultValues={selectedSubCategory}
            onSubmitEditForm={onUpdateSubCategory}
            onCancel={() => setModalSubCategoryEdit(false)}
          />
        </div>
      </Modal>

      <Modal display={false} onAccept={() => null} onClose={() => setModal}>
      <div>
          <h1 className="font-bold text-primary-900 dark:text-gray-400 mb-8 col-span-12">
            Editar subcategoria
          </h1>
          <SubCategoryEditForm
            defaultValues={selectedSubCategory}
            onSubmitEditForm={onUpdateSubCategory}
            onCancel={() => setModalSubCategoryEdit(false)}
          />
        </div>
      </Modal>

      <ModalConfirm
        title={'¿Está seguro que desea eliminar la subcategoria?'}
        displayConfirmModal={displayConfirm}
        onConfirm={async () => {
          if (subCategoryToEdit) {
            try {
              addAlert({
                message: 'Eliminando subcategoria...',
                status: 'loading',
              })
              // await dispatch(removeSubcategory(subCategoryToEdit))
              let response = await axios.delete(
                `${server}/inventory/subcategory?id=${subCategoryToEdit.id}`
              )
              setSubCategories(
                (prevSubCategories) =>
                  prevSubCategories &&
                  prevSubCategories?.filter(
                    (v) => v.id !== response.data.subcategory.id
                  )
              )
              addAlert({
                message: 'Subcategoria eliminada con éxito',
                status: 'success',
              })
            } catch (e) {
              addAlert({
                message: 'Error al eliminar subcategoria',
                status: 'error',
              })
            } finally {
              setDisplayConfirm(false)
            }
          }
        }}
        onCancel={() => setDisplayConfirm(false)}
      ></ModalConfirm>

      {categories.length === 0 ? (
        <>
          <Empty
            animationProps={{
              animation: LocationAnimation,
              width: 370,
              height: 370,
            }}
          >
            <p className="font-semibold max-w-xs text-center my-4 text-sm text-coolGray-500">
              Aqui puedes crear, eliminar y editar categorias.
            </p>
          </Empty>
        </>
      ) : (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6 px-1">
          {categories.map((category) => (
            <CategoryCard
              setAddNew={() => setAddNewSub(true)}
              key={category.id}
              category={category}
              setModal={setModal}
              setModalSubCategory={async () => {
                let response: AxiosResponse<{
                  subcategories: {
                    id: string
                    name: string
                    description: string
                    code: string
                    idCategory: string
                  }[]
                }> = await axios.get(
                  `${server}/inventory/subcategory?idCategory=${category.id}`
                )
                setSubCategories(response.data.subcategories)
                setModalSubCategory(true)
              }}

              setEditingCategory={setEditingCategory}
              setSelectedCategory={setSelectedCategory}
              onDelete={() => {
                setIdCategoryToDelete(category.id)
                setDisplayConfirmCategory(true)
                // onDelete()
              }}
              iconType="store"
            />
          ))}
        </div>
      )}

      <Modal display={addNewSub} xlClasses="xl:w-2/6" onClose={() => setAddNewSub(false)}>
      <h1 className="font-bold text-primary-900 dark:text-gray-400 mb-8 col-span-12">
            Añadir subcategoria
          </h1>     
      <SubCategoryEditForm
            defaultValues={selectedSubCategory}
            onSubmitEditForm={async (values) =>  {
              addAlert({ message: 'Creando subcategoria...', status: 'loading' })
              try {
                await axios.post(`${server}/inventory/subcategory`, {
                  name: values.name,
                  code: values.code,
                  idCategory: editingCategory?.id
                })
                setAddNewSub(false)
                addAlert({ message: 'Subcategoria creada con exito', status: 'success' })
              } catch (err) {
                addAlert({ message: 'Error al crear subcategoria', status: 'error' })
              }
            }}
            onCancel={() => setAddNewSub(false)}
          />
      </Modal>
      <ModalConfirm
        title={'¿Está seguro que desea eliminar la categoria?'}
        displayConfirmModal={displayConfirmCategory}
        onConfirm={() => onDelete()}
        onCancel={() => setDisplayConfirmCategory(false)}
      ></ModalConfirm>
    </>
  )
}

export default Category

interface CategoryProps {
  setHeaderActions: React.Dispatch<React.SetStateAction<HeaderActions | null>>
}
